import axios from "axios";
import { API } from "../config";

const path = "/avisos";
const pathTipo = "/tipo";


class AvisosService {
  getAvisos() {
    return axios.get(API + path)
  }
  getTiposAvisos(tipoAviso) {
    return axios.get(API + path + pathTipo + `/${tipoAviso}`)
  }


  getTiposAvisosPaginado(tipoAviso, filters) {
    const {
      pageSize,
      page,
      sortField,
      sortType,
    } = filters;

    return axios.get(API + path + pathTipo + `/paginado`, {
      params: {
        pageSize: pageSize !== "" ? pageSize : 10,
        page: page !== "" ? page : 0,
        tipoAviso: tipoAviso !== "" ? tipoAviso : 0,
        sortField: sortField ? sortField : undefined,
        sortType: sortType ? sortType : undefined
      }
    });
  }


}
const instanceAvisos = new AvisosService();
export default instanceAvisos;